// extracted by mini-css-extract-plugin
export default {"arrow":"SortingArrow_arrow__xJsqu","arrowPointingUp":"SortingArrow_arrowPointingUp__OR67X"};